const burgerMenu = {

    init () {

        let body = document.body;
        let burgerMenu = document.querySelector('.burger');
        let mainNav = document.querySelector('.main-nav')

        if(burgerMenu){

            
            const documentWidth = document.documentElement.clientWidth;
            const windowWidth = window.innerWidth;
            const scrollBarWidth = windowWidth - documentWidth;

            burgerMenu.addEventListener('click', function(){
                burgerMenu.classList.toggle('active-menu');
                mainNav.classList.toggle('active-menu');
                body.classList.toggle('noscroll');

                if(body.classList.contains('noscroll')){
                    body.style.paddingRight = scrollBarWidth + 'px';
                } else {
                    body.style.paddingRight = 0 + 'px';
                }
                
            })
           
            ;

        }
    }
}

export default burgerMenu;